import React from "react";

const CashEdit = React.createContext()

export default CashEdit